import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFaceAww = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 729,
	height: 727,
	viewBox: "0 0 729 727",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_3802_6262)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M728.69 344.84C728.69 147.48 584.88 0 385.02 0C282.2 0 194.23 39.32 133.02 104.22C189.94 61.62 262.13 36.9 343.66 36.9C543.52 36.9 687.33 184.38 687.33 381.74C687.33 477.05 653.42 561.1 595.66 622.35C678.27 560.53 728.69 461.05 728.69 344.84Z",
					fill: "#FFA6DD"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M41.35 344.84C41.35 249.53 75.26 165.48 133.02 104.23C50.42 166.05 0 265.52 0 381.73C0 578.02 143.81 726.57 343.67 726.57C446.49 726.57 534.47 687.25 595.67 622.35C538.75 664.95 466.56 689.67 385.03 689.67C185.17 689.67 41.36 541.13 41.36 344.83L41.35 344.84Z",
					fill: "#D900D6"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M343.67 36.9004C262.14 36.9004 189.95 61.6304 133.03 104.22C75.2699 165.48 41.3599 249.52 41.3599 344.83C41.3599 541.12 185.17 689.67 385.03 689.67C466.56 689.67 538.76 664.94 595.67 622.35C653.43 561.09 687.34 477.05 687.34 381.74C687.34 184.39 543.53 36.9004 343.67 36.9004Z",
					fill: "#FF5FA2"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M335.099 260.399L331.06 295.339C330.864 297.038 329.395 298.301 327.686 298.24L289.387 296.884C286.274 296.774 284.775 300.656 287.153 302.667L314.075 325.429C315.106 326.301 315.498 327.716 315.061 328.994L303.884 361.714C302.826 364.809 306.454 367.376 309.021 365.348L345.256 336.728C346.373 335.845 347.932 335.785 349.115 336.577L381.002 357.949C383.903 359.893 387.43 356.56 385.652 353.554L371.45 329.547C370.563 328.048 371.003 326.118 372.45 325.15L400.412 306.461C403.109 304.659 401.833 300.454 398.589 300.454H360.206C358.871 300.454 357.669 299.645 357.167 298.407L341.397 259.542C340.12 256.395 335.489 257.025 335.099 260.399Z",
					fill: "#FFB331"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M578.423 262.932L589.838 298.186C590.276 299.539 591.536 300.455 592.958 300.455H629.654C632.827 300.455 634.151 304.511 631.59 306.383L605.644 325.351C604.42 326.246 603.969 327.862 604.553 329.262L615.71 356.017C616.958 359.011 613.567 361.807 610.866 360.011L581.691 340.611C580.7 339.952 579.428 339.882 578.37 340.428L538.972 360.768C536.046 362.278 532.967 359.017 534.644 356.183L550.4 329.548C551.287 328.049 550.848 326.119 549.4 325.151L520.562 305.877C517.949 304.13 519.052 300.063 522.19 299.876L558.393 297.722C559.73 297.643 560.885 296.758 561.309 295.487L572.191 262.903C573.194 259.901 577.448 259.92 578.423 262.932Z",
					fill: "#FFB331"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M423.298 343.967C421.207 341.954 418.46 340.66 415.524 340.49C412.589 340.319 409.725 341.267 407.534 343.152C405.343 345.037 403.977 347.727 403.708 350.654C403.437 353.583 404.306 356.492 405.984 358.861C407.224 360.564 408.476 362.171 409.852 363.797C421.758 378.229 441.205 389.51 462.269 389.136C483.343 389.053 502.143 377.674 513.95 363.469C515.311 361.864 516.547 360.278 517.776 358.598C519.331 356.404 520.184 353.72 519.993 350.997C519.802 348.275 518.604 345.755 516.626 343.96C514.648 342.165 512.024 341.215 509.296 341.289C506.567 341.362 503.979 342.47 501.945 344.23C500.675 345.302 499.438 346.286 498.144 347.273C486.649 356.048 474.153 361.109 462.021 361.169C449.893 361.334 437.686 356.254 426.861 347.13C425.643 346.106 424.483 345.082 423.298 343.967Z",
			fill: "#4D122C"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_3802_6262",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 728.69,
				height: 726.57,
				fill: "white"
			})
		}) })
	]
});
export default SvgFaceAww;
